import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { dashboardApi } from "@/lib/dashboard";

export function QuotesWidget() {
  const q = useQuery({
    queryKey: ["dashboard", "quotes"],
    queryFn: () => dashboardApi.quotes(),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });

  return (
    <Card>
      <CardHeader><CardTitle>Quotes</CardTitle></CardHeader>
      <CardContent>
        {q.isLoading ? (
          <Skeleton className="h-9 w-28" />
        ) : q.isError || !q.data ? (
          <p className="text-sm text-muted-foreground">Couldn't load quotes.</p>
        ) : q.data.awaitingApproval === 0 && q.data.expiringSoon === 0 ? (
          <p className="text-sm text-muted-foreground">Nothing awaiting approval.</p>
        ) : (
          <Link to="/quotes?status=Sent" className="block hover:underline">
            <span className="text-3xl font-semibold">{q.data.awaitingApproval}</span>{" "}
            <span className="text-sm text-muted-foreground">awaiting approval</span>
            {q.data.expiringSoon > 0 && (
              <span className="text-amber-600 text-sm"> · {q.data.expiringSoon} expiring soon</span>
            )}
          </Link>
        )}
      </CardContent>
    </Card>
  );
}
